/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_tag helper in views (e.g <%= image_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
// //

const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import 'core-js/stable'
import 'regenerator-runtime/runtime'
// require("@rails/ujs").start()
import { } from "jquery-ujs"

require("underscore")
require("jquery-ui/ui/widgets/autocomplete")
require("jquery-ui/ui/widgets/dialog")
require('jquery')
require("@nathanvda/cocoon")
require("jquery-ui")
require("../src/utilits/activerecord_sortable")

import 'multiple-select/dist/multiple-select.js'
import * as bootstrap from 'bootstrap';

window.bootstrap = bootstrap;

import "bootstrap-select"
import 'jquery-ui-sortable'
import "chartkick/chart.js"

import "daterangepicker"
import "../src/utilits/drivu_global_functions";
import "../src/utilits/push.js.erb";
import "../src/utilits/prototypes"
import { } from '../lib/jquery.iframe-transport';
import { } from '../lib/jquery.remotipart.library';
import 'trix';

import "jquery-hoverintent";
import "bootstrap5-toggle";

// import { html2pdf } from 'html2pdf.js'
export var toastr = require('toastr')
// $(document).ready(() => { require("bootstrap-colorpicker");})
// export { default as ActiveCategoryTab } from '../src/utilits/active_category_tab'
export { MenuItemView, ImageFile } from '../src/utilits/menu_item';
export * as globalFun from '../src/utilits/drivu_global_functions'
export { date_range_picker } from '../src/utilits/date_range_picker'
export { BranchCategory } from '../src/utilits/branch_categories'
export { DrivuSocketIO } from '../src/utilits/drivu_socket_io'
export { GoogleMap } from '../src/utilits/google_map'
export { WorkingDay } from '../src/utilits/working_day'
export { DrawBranchMenuItem, BranchPromotion } from '../src/utilits/promotions'
export { BranchMenuView } from '../src/views/branch_menu_view'
export { BranchMenuExtraView } from '../src/views/branch_menu_extra_view'
export { OrderView } from '../src/views/order_view'
export { OrderDetailsView } from '../src/views/order_details_view'
export { ModeratorBranchesView } from '../src/views/moderator/moderator_branches_view'
export { ModeratorBranchView } from '../src/views/moderator/moderator_branch_view'
export { CategoryView } from '../src/views/category_view'
export { BranchMenuImageView } from '../src/views/branch_menu_image_view'
export { dashboardMessage } from '../src/views/dashboard_messages'
export { TagSimulatorView } from '../src/views/tag_simulator_view'
export { userShopLoyaltyView } from '../src/views/user_shop_loyalty_view'
export { SponsorCampaignView } from '../src/views/sponsor_campaign_view'
export { OrderTestsView } from '../src/views/order_tests_view'
export { EditUserView } from '../src/views/edit_user_view'
export { PredictionTestsView } from '../src/views/prediction_tests_view'
export { DiscoverEmulationView } from '../src/views/discover_emulation_view'
export { ShopBranchesView } from '../src/views/shop_branches_view'
export { workingHoursView as workingHoursView } from '../src/views/moderator/working_hours_view'
export { PickUpHourView as pickupHoursView } from "../src/views/moderator/pickup_hour_view"
export { DrivuMarker as DrivuMarker } from "../src/utilits/drivu_marker"
export { Branch as Branch } from "../src/utilits/branch.js"
export { GoogleWorkingHoursPeriod as GoogleWorkingHoursPeriod } from "../src/utilits/google_place_working_hours"
export { uploadShopLogo as uploadShopLogo } from "../src/utilits/upload_shop_logo"
export { StatementOfAccountView as StatementOfAccountView } from "../src/views/statement_of_account_view"
export { ShopOrderView as ShopOrderView } from "../src/views/shop_order_view"
export { AdminsPagesView as AdminsPagesView } from "../src/views/admins_pages_view"
export { ZoneView as ZoneView } from "../src/views/zone_view"
export { Indoor } from "../src/utilits/indoor"
export { CustomerLaneOrder } from "../src/utilits/customer_lane_order";
export { PendingShopOrdersView as PendingShopOrdersView } from "../src/views/multi_shop_agent/pending_shop_orders_view"
export { DrivuMap as DrivuMap } from "../src/utilits/drivu_map"
export { AgentTaskCalender as AgentTaskCalender } from "../src/utilits/agent_task_calender";
export { CreditCardView } from "../src/utilits/credit_card_view";
export { AdvPaymentMethodViews as AdvPaymentMethodViews } from "../src/views/adv_payment_method_view";
export { PaymentMethod } from "../src/utilits/payment_method";
export { DrivuObjects } from "../src/utilits/drivu_objects";
export { AutocompleteServiceMap } from "../src/utilits/autocomplete_service_map";
export { DatesChartView } from "../src/views/dates_chart_view"
export { MapView } from "../src/views/map_view"
export { ParkingMapView } from "../src/views/parking_map_view"
export { InvoicesView } from "../src/views/invoices_view"
export { ActiveRecordSortable } from "../src/utilits/activerecord_sortable"
export { SuggestiveInput } from "../src/views/suggestive_input"
export { WorkingHoursPlan } from "../src/views/working_hours_plan"
export { LiveOrdersView } from "../src/views/live_orders_view"
export { SimulateUserMovement } from "../src/utilits/simulate_user_movement";
export { StateCell } from "../src/views/state_cell";
export { MultiColorPicker } from "../src/views/multi_color_picker";
export { MapPreview } from "../src/utilits/map_preview";
export { MenuPreview } from "../src/views/menu_preview";
export { ContactRequestCell } from "../src/views/contact_request_cell";
export { RangeSplitter } from "../src/views/range_splitter.js"
export { AnnouncementForm } from "../src/views/announcement_form.js"
export { AiChat } from "../src/views/ai_chat.js";
export { ScrollablePagination } from "../src/utilits/scrollable_pagination.js";
export { PhoneField } from "../src/views/phone_field.js"
export { LiveEditField } from "../src/views/live_change_field.js"
export { AiSearchCardView } from "../src/views/ai_search_card_view.js"
import flatpickr from "flatpickr";

window._ = _;
window.async = require('async')
window.html2pdf = require('html2pdf.js')
window.O = (selector) => { return Packs.application.DrivuObjects.findForElement(selector) }
window.O.on = (e, cb) => { Packs.application.DrivuObjects.on(e, cb) }
window.O.emit = (e, data) => { Packs.application.DrivuObjects.emit(e, data) }
window.p = (content) => { console.log(content) }

// window.onerror = function myErrorHandler(errorMsg, url, lineNumber) {
// 	$('#errorResult').append(`Error occured: ${errorMsg} - ${url} - ${lineNumber}`);//or any message
// 	return false;
// }

window.isMobile = function () {
	let check = false;
	(function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
	return check;
};

window.isMobileDevice = function () {
	return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

window.isIphoneDevice = function () {
	return isMobileDevice() && (/iPhone/i.test(navigator.userAgent) || /iPad/i.test(navigator.userAgent));
}

window.isAndroidDevice = function () {
	return isMobileDevice() && (/Android/i.test(navigator.userAgent));
}

window.redirectInstall = () => {
	var url = window.isAndroidDevice() ? "https://play.google.com/store/apps/details?id=co.m4.drivu&pcampaignid=web_share" : "https://apps.apple.com/ae/app/drivu-your-drive-thru-orders/id1207582756"
	window.location.href = url;
}

$(document).ready(() => {
	flatpickr($('.multi-calendar'), {
		mode: "multiple"
	});

	$('.download-app-btn').on('click', function () {
		var url = window.isAndroidDevice() ? "https://play.google.com/store/apps/details?id=co.m4.drivu&pcampaignid=web_share" : "https://apps.apple.com/ae/app/drivu-your-drive-thru-orders/id1207582756"
		window.location.href = url;
	});

})

$(document).ajaxError(function (e, request) {
	var flash = JSON.parse(request.getResponseHeader('X-Flash-Messages'));
	if (!flash) return;
	if (flash.notice) { toastr.info(flash) }
	if (flash.error) { toastr.error(flash.error) }
})


document.addEventListener('DOMContentLoaded', () => {

	$('*[data-trix-button-group="text-tools"]').remove();
	$('*[data-trix-button-group="history-tools"]').remove();

	document.querySelectorAll('[context]').forEach((element) => {
		Packs.application.DrivuObjects.newForElement(element);
	});

	Packs.application.globalFun.onElementInserted('body', '[context]', function (element) {
		Packs.application.DrivuObjects.newForElement(element);
	});

	Packs.application.globalFun.onElementInserted('body', '[multipleSelect]', function (element) {
		$(element).multipleSelect();
	});

	new Packs.application.date_range_picker({
		selector: $('.range-datePicker'),
		config: { format: 'YYYY/MM/DD', locale: { cancelLabel: 'Clear', format: 'YYYY/MM/DD' } },
	});

	new Packs.application.date_range_picker({
		selector: $('.single-datePicker'),
		config: { format: 'YYYY-MM-DD', locale: { cancelLabel: 'Clear', format: 'YYYY-MM-DD' }, singleDatePicker: true }
	});

	window.createElementFromHTML = (htmlString) => {
		var div = document.createElement('div');
		div.innerHTML = htmlString.trim();
		return div.firstChild;
	}

	$('.call_shop_link').on('click', function () {
		window.location.href = 'tel:' + $(this).text();
	});

	$('.call_shop_link').on('ajax:success', function (event, data, status, xhr) {
		$(this).css("color", "BlueViolet");
	});

	$('body').on('click', '.online-repay', function () {
		var $this = $(this);
		$this.prop('disabled', true);
		$this.children('.spinner-border').show();
		var orderId = $this.attr('id').split('-').pop();
		$.ajax({
			url: '/admins/order_payment_transactions/' + orderId,
			method: 'PUT',
			data: {},
			success: function () {
				location.reload();
			},
			error: function (res) {
				toastr.error(res.responseJSON.error);
			}
		});

		setTimeout(function () {
			$this.prop('disabled', false);
			$this.children('.spinner-border').hide();
		}, 8000);
	});

	$('.inline-dashboard-link').hoverIntent(function (e) {
		$(this).append("<div class='current-page'></div>");
	}, function () {
		$(this).find('.current-page').remove();
	})

	// $('select').multipleSelect();
});

// alert(Notification.permission);
if (!("Notification" in window)) {
	// alert("This browser does not support desktop notification");
	$('#errorResult').append("This browser does not support desktop notification");
	console.log("This browser does not support desktop notification");
}
// Let's check whether notification permissions have already been granted
else if (Notification.permission === "granted") {
	$('#errorResult').append("Permission to receive notifications has been granted");
}
else if (Notification.permission === 'denied') {
	console.log('Allow push notification token to get order status update');
}
// Otherwise, we need to ask the user for permission
else if (Notification.permission !== 'denied') {
	Notification.requestPermission(function (permission) {
		// If the user accepts, let's create a notification
		if (permission === "granted") {
			console.log("Permission to receive notifications has been granted");
		}
	});
}

if (("Notification" in window) && navigator.serviceWorker) {

	navigator.serviceWorker.register('/serviceworker.js')
		.then(function (reg) {
			navigator.serviceWorker.ready.then((serviceWorkerRegistration) => {
				serviceWorkerRegistration.pushManager
					.subscribe({
						userVisibleOnly: true,
						applicationServerKey: window.vapidPublicKey
					}).then((sub) => {
						window.drivu.saveNotificationToken(sub.toJSON());
					});
			});
		});
} else {
	console.error('Service worker is not supported in this browser');
}
